import script from "./license.vue?vue&type=script&setup=true&lang=js"
export * from "./license.vue?vue&type=script&setup=true&lang=js"

import "./license.vue?vue&type=style&index=0&id=49f9d1b4&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f9d1b4"]])

export default __exports__